import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SVGIcon, trashIcon,} from '@progress/kendo-svg-icons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { GridService } from 'app/services/grid.service';
import { DrakeImagePreviewComponent } from "../../../drake-components/drake-image-preview/drake-image-preview.component";
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@ngneat/transloco';
import { PaymentUtilitiesService, Module } from '../payment-utilities.service';
import { Router } from '@angular/router';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

interface Price {
  id: string;
  title: string;
  description: string;
  period: string;
  price: number;
}

interface ModuleBase {
  _id: string;
  title: string;
  description: string;
  image: {
    id: string;
    dataUrl: string;
    fileName: string;
  };
  price: Price[];
  selectedPriceId:string;
}


@Component({
  selector: 'app-module-management',
  standalone: true,
  imports: [
    DrakeImagePreviewComponent, 
    CommonModule, 
    TranslocoPipe, 
    ButtonsModule,
    IconsModule,
    MatOptionModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './module-management.component.html',
  styleUrl: './module-management.component.scss',
  providers: [TranslocoPipe],
})
export class ModuleManagementComponent implements OnInit{

  constructor(private gridService: GridService, private translocoPipe: TranslocoPipe, private paymentUtilitiesService:PaymentUtilitiesService, private router: Router) { }
  //array con dentro i moduli da API
  public dataModules: any[] = [];
  //array con dentro i plans da API
  public price: any[] = [];
  //array che combina i precendenti due array
  public createdModules: ModuleBase[] = [];

  selectedPriceId: string = '';


  public deleteIcon: string = "trash";
  public deleteSVG: SVGIcon = trashIcon;
  public somma: number = 0;
  public priceString ='';
  protected buttonActive: any[]=[];

  ngOnInit(): void {
    this.createMenuModules();
    console.log("moduli",this.createdModules);
    
  }
  

  private loadData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.dataModules = [];
      const requestData = {
        ViewCode: 'MODULES.DEFAULT',
        Filter: '{}',
        Sort: '',
        Page: 0,
        PageSize: 0,
        Language: "",
        Cache: false,
        ExtraData: {}
      };
    
      this.gridService.getScopeData('MODULES', 'READ', requestData).subscribe(
        (response) => {
          if (response?.data) {
            this.dataModules = response.data.map((item: any) => {
              for (let key in item) {
                if (item[key] === null || item[key] === undefined) {
                  item[key] = ''; 
                }
              }
              return item;
            });
            //console.log('gridView', this.dataModules);
            resolve(); 
          }
        },
        (error) => {
          console.error('Errore durante il caricamento dei dati:', error);
          reject(error); 
        }
      );
    });
  }
  
  private loadPrice(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.price = [];
      const requestData = {
        ViewCode: 'PLANS.DEFAULT',
        Filter: '{}',
        Sort: '',
        Page: 0,
        PageSize: 0,
        Language: "",
        Cache: false,
        ExtraData: {}
      };
    
      this.gridService.getScopeData('PLANS', 'READ', requestData).subscribe(
        (response) => {
          if (response?.data) {
            this.price = response.data.map((item: any) => {
              for (let key in item) {
                if (item[key] === null || item[key] === undefined) {
                  item[key] = ''; 
                }
              }
              return item;
            });
            //console.log('price', this.price);
            resolve(); 
          }
        },
        (error) => {
          console.error('Errore durante il caricamento dei dati:', error);
          reject(error);
        }
      );
    });
  }
  
  //Prendiamo il risultato delle due API e costruiamo una serie di oggetti di tipo ModuleBase[]
  protected async createMenuModules(): Promise<ModuleBase[]>{
    this.createdModules=[];

    await this.loadData();
    await this.loadPrice();
    //Creiamo il mdoulo
    for(let i=0;i<this.dataModules.length;i++){
      const module: ModuleBase={
        _id: this.dataModules[i]._id,
        title: this.dataModules[i].Title, 
        description: this.dataModules[i].Description,
        image: {
          id: this.dataModules[i].Image?.id || '',
          dataUrl: this.dataModules[i].Image?.dataUrl || '', 
          fileName: this.dataModules[i].Image?.fileName || ''
        },
        price: [],
        selectedPriceId: ''
      }
      this.createdModules.push(module);
      
      //Alleghiamo al modulo i vari prezzi
      for(let cont=0; cont<this.price.length;cont++){
        const moduleCode:string=this.price[cont].ModuleCode.value;
        if(module._id == moduleCode){
          const createdPrice: Price={
            id: this.price[cont]._id,
            title: this.price[cont].Title,
            description: this.price[cont].Description,
            period: this.price[cont].Period.value,
            price: this.price[cont].Price
          }
          module.price.push(createdPrice);
        }
      }

      //console.log("createdModules:",this.createdModules[i]);   
    }
    return this.createdModules;
  }
  

  get cart(): Module[] {    
    return this.paymentUtilitiesService.cart;
  }


  
  //Funzione per formattare il prezzo
  protected priceFormatter(price:number):string{
    return this.paymentUtilitiesService.priceFormatter(price)
    }
   
  //aggiunge il modulo al carrello
  protected addToCart(id:string , title:string,  idPlans: string, price: number,): Module[]{
    return this.paymentUtilitiesService.addToCart(id, title, idPlans, price);
  }
  //elimina il modulo dal carrello
  protected removeModule(id:string):Module[]{
    return this.paymentUtilitiesService.removeModule(id);
  }

  //Ritrona la somma del carrello
  protected storeAmount(cart: Module[]):number{
    this.somma = this.paymentUtilitiesService.storeAmount(cart);
    return this.somma;
  }
  //Reindirizzamento al module payment
  protected goToModulePayment(){
    this.router.navigate(['/module-payment']);
  }
  //Funzione per controllare se il carrello è vuoto, serve per bloccare il pulsante
  protected cartIsEmpty():boolean{
    if(this.paymentUtilitiesService.cart.length<1){
      return true;
    }else{
      return false;
    }
  }

  //Funzioni per attivare e disattivare il pulsante ACQUISTA
  buyActive(moduleId: string) {
    let present: boolean=false;
    for (let i = 0; i < this.buttonActive.length; i++) {
      if (this.buttonActive[i] == moduleId) {
        present = true;
      }
    }
    if (present) {
      this.buttonActive.splice(this.buttonActive.indexOf(moduleId), 1);
    }else {
      this.buttonActive.push(moduleId);
    }
    
    //console.log("buttonActiveMap", this.buttonActive);
  }

  buyActivePresent(moduleId: string) {
    
    for (let i = 0; i < this.buttonActive.length; i++) {
      if (this.buttonActive[i] == moduleId) {
        return true;
      }
    }
    return false;
  }
  
  //Controlla se il modulo è già stato aggiunto al carrello, se si il tasto aggiungi sul 
  //componente viene disattivato
  protected cartIsPresent(id:string):boolean{
   return this.paymentUtilitiesService.cartIsPresent(id);
  }
  
}